import { animate, keyframes, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import * as kf from '../../core/keyframes';
import { IStyleNode, SituViewWebApiClient, ThemeType, ThumbnailType, UploadStyleThumbnailRequest, UploadStyleThumbnailResponse } from 'situview-webapi-client';
import { IListStyleNode } from 'src/app/views/admin/styles/style-category-edit/style-category-edit.component';
import { AssetUploadComponent } from '../asset-upload/asset-upload.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'style-card',
  templateUrl: './style-card.component.html',
  styleUrls: ['./style-card.component.less'],
  animations: [
    trigger('cardAnimator', [
      transition('* => wobble', animate(1000, keyframes(kf.wobble))),
      transition('* => swing', animate(1000, keyframes(kf.swing))),
      transition('* => jello', animate(1000, keyframes(kf.jello))),
      transition('* => zoomOutRight', animate(1000, keyframes(kf.zoomOutRight))),
      transition('* => slideOutLeft', animate(1000, keyframes(kf.slideOutLeft))),
      transition('* => rotateOutUpRight', animate(1000, keyframes(kf.rotateOutUpRight))),
      transition('* => flipOutY', animate(1000, keyframes(kf.flipOutY))),
      transition('* => headShake', animate(1000, keyframes(kf.headShake)))
    ])
  ]
})
export class StyleCardComponent implements OnInit, OnChanges {

  @Input() item: IListStyleNode | undefined;
  @Input() readonly: boolean = true;
  @Input() searchValue: string = "";
  @Input() selected: boolean = false;
  @Input() animationState: string = '';
  @Input() thumbnailUrl: string | undefined;
  @Input() showCategory: boolean = false;

  themeTypeEnum = ThemeType;
  thumbnailData: string | undefined;

  constructor(
    private situViewApiClient: SituViewWebApiClient,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {}

  @ViewChild(AssetUploadComponent) assetUploadComponent: AssetUploadComponent | undefined;

  triggerChildFileUpload(event: MouseEvent) {
    event.stopPropagation();
    if (this.assetUploadComponent) {
      this.assetUploadComponent.triggerFileUpload();
    }
  }

  onAssetLoad(assetBase64: string) {
    if (assetBase64) {
      this.thumbnailData = assetBase64;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.animationState) {
      this.startAnimation(changes.animationState.currentValue);
    }
  }

  cancelThumbnailUpload() {
    this.thumbnailData = undefined;
  }
  
  saveThumbnailUpload() {
    if (!this.item?.id || !this.thumbnailData) {
      return;
    }

    let request = new UploadStyleThumbnailRequest();
    request.companyId = this.item.companyId;
    request.id = this.item.id;
    request.thumbnail = this.thumbnailData.split(',')[1];
    request.thumbnailType = ThumbnailType.Style;

    this.situViewApiClient.uploadStyleThumbnail(request)
      .then((response: UploadStyleThumbnailResponse) => {
        if (response.success) {
          this.item!.thumbnailUrl = response.thumbnailUrl;
          this.thumbnailData = undefined;
          this.snackBar.open(`Thumbnail successfully updated!`, 'OK', { duration: 2000 });
        } else {
          this.snackBar.open(`Could not save thumbnail. Refresh page.`, 'OK', { duration: 2000 });
        }
      })
      .catch(x => {
        this.snackBar.open(`Failed to upload thumbnail`, 'OK', { duration: 2000 });
      });
  }

  startAnimation(state: string) {
    if (!this.animationState) {
      this.animationState = state;
    }
  }

  resetAnimationState() {
    this.animationState = '';
  }
}
